export default class FilterableTeaserCardListSection {
    static init() {
        if (document.body.classList.contains('neos-backend')) {
            return;
        }

        document.addEventListener('DOMContentLoaded', function () {
            const filterableTeaserLists = document.querySelectorAll('.filterable-teaser-list');
            filterableTeaserLists.forEach(function (filterableTeaserList) {
                new FilterableTeaserCardListSection(filterableTeaserList);
            });
        });
    }

    constructor(element) {
        this.element = element;
        this.currentFilterCategory = null;
        this.currentFilterSubcategory = null;

        document.addEventListener('click', (event) => {
            const badge = event.target.closest('.badge');
            if (!badge) {
                return;
            }

            // Ignore badges that are not part of the current filterable teaser list
            if (!this.element.contains(badge)) {
                return;
            }

            const filterCategory = badge.getAttribute('data-filter-category');
            if (filterCategory && this.currentFilterCategory !== filterCategory) {
                this.resetAllSubcategories();
                this.showSubcategories(filterCategory);
                this.currentFilterCategory = filterCategory;
                this.currentFilterSubcategory = null;
            } else if (filterCategory && this.currentFilterCategory === filterCategory) {
                this.resetAllSubcategories();
                this.currentFilterCategory = null;
                this.currentFilterSubcategory = null;
            }

            const filterSubcategory = badge.getAttribute('data-filter-subcategory');
            if (filterSubcategory && this.currentFilterSubcategory !== filterSubcategory) {
                this.currentFilterSubcategory = filterSubcategory;
            } else if (filterSubcategory && this.currentFilterSubcategory === filterSubcategory) {
                this.currentFilterSubcategory = null;
            }

            this.filter();
            this.setBadgeStatuses();
        })
    }

    filter() {
        const selectedCategory = this.currentFilterSubcategory || this.currentFilterCategory || 'all';
        const teasers = this.element.querySelectorAll('.filterable-teaser-list__item');
        teasers.forEach(function (teaser) {
            const visibleFor = JSON.parse(teaser.getAttribute('data-visible-for'));
            if (selectedCategory === 'all' || visibleFor.indexOf(selectedCategory) > -1) {
                teaser.classList.remove('hidden');
            } else {
                teaser.classList.add('hidden');
            }
        });
    }

    showSubcategories(category) {
        const subcategory = this.element.querySelector('.filterable-teaser-list__filter-subcategories-item[data-category="' + category + '"]');
        subcategory.classList.add('active');
    }

    resetAllSubcategories() {
        const subcategories = this.element.querySelectorAll('.filterable-teaser-list__filter-subcategories-item');
        subcategories.forEach(function (subcategory) {
            subcategory.classList.remove('active');
        });
    }

    setBadgeStatuses() {
        const badges = this.element.querySelectorAll('.badge');
        badges.forEach((badge) => {
            if (badge.dataset.filterCategory === this.currentFilterCategory || badge.dataset.filterSubcategory === this.currentFilterSubcategory) {
                badge.classList.add('badge--primary');
                badge.classList.remove('badge--secondary');
            } else {
                badge.classList.remove('badge--primary');
                badge.classList.add('badge--secondary');
            }
        });
    }
}
